var map = {
	"./arch/arch-inf-sel.svg": 24681,
	"./arch/arch-sup-sel.svg": 53008,
	"./bridge/bridge-sel.svg": 10953,
	"./emiarch/emiarch-1-sel.svg": 52747,
	"./emiarch/emiarch-2-sel.svg": 15384,
	"./emiarch/emiarch-3-sel.svg": 86329,
	"./emiarch/emiarch-4-sel.svg": 50390,
	"./mouth/mouth-sel.svg": 26137,
	"./sest/sest-1-sel.svg": 16495,
	"./sest/sest-2-sel.svg": 53916,
	"./sest/sest-3-sel.svg": 3085,
	"./sest/sest-4-sel.svg": 18194,
	"./sest/sest-5-sel.svg": 12115,
	"./sest/sest-6-sel.svg": 7904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47257;